import { createStyles, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function (theme) {
    var _a, _b;
    return createStyles({
        iconoCnt: (_a = {
                padding: '1rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
            _a[theme.breakpoints.down('sm')] = {
                display: 'flex',
                padding: '1rem 0',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'flex-start',
            },
            _a),
        iconoCntPointer: {
            cursor: 'pointer',
        },
        icono: (_b = {},
            _b[theme.breakpoints.down('sm')] = {
                transform: 'translateX(10px)',
            },
            _b),
        tooltip: {
            visibility: 'hidden',
            opacity: '0',
            cursor: 'pointer',
            position: 'absolute',
            left: '0',
            top: '0',
            zIndex: 5,
        },
        tooltopVisible: {
            visibility: 'visible',
            opacity: '1',
        },
    });
});
export default useStyles;
